import * as actionTypes from './actionsTypes';

export function getHolderZoneReport(params) {
  /**
   * @param clientId
   * @param clientReference
   * @param siteId
   * @param startTime
   * @param endTime
   */
  return {
    type: actionTypes.HOLDER_ZONE_REPORT_GET,
    payload: {
      params,
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/actions/holderZoneReport.js